<template>
    <section>
        <b-modal :active.sync="showManualModal"
        		has-modal-card
            	trap-focus
                aria-role="dialog"
                aria-modal
                scroll="keep">
    		<form action="">
                <div class="modal-card" style="width: 600px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Manual</p>
                    </header>

                    <section class="modal-card-body">
                    	<h1>
                    		<strong> Welcome to the open beta of MAPtm trafficmovies.
                    		<br>
                    		Enjoy our tool, any feedback is greatly appreciated.</strong>
						</h1>
						<br>
                    	<ol>
                    		<li>Sign up and login</li>
                    		<li>Zoom to the area of interest</li>
                    		<li>Select a map layer</li>
                    		<li>Select a time range with a maximum of 12 hours</li>
                    		<li>Select the desired data</li>
                    		<li>Click the Generate button</li>
                    		<li>Watch and download your traffic movie</li>
                    	</ol>

                    	<br>
                    	<video controls autoplay muted loop>
							<source :src="'https://traffic-movies-webapp-prod.s3.eu-central-1.amazonaws.com/TrafficMovies.mp4'" type="video/mp4"/>
						</video>
                    </section>

                    <footer class="modal-card-foot">
                    	<div class="has-text-centered" style="width: 100%">
                			<b-button type="is-primary" @click="changeManualModalState">Let's go!</b-button>
						</div>
                    </footer>

                </div>
            </form>
    	</b-modal>
    </section>
</template>

<script>
	export default {
		name: 'ManualModal',

		mounted() {
			if (!localStorage.repeat_visit) {
				this.$store.commit('toggleManualModal')
				localStorage.repeat_visit = true
			}
		},

		computed: {
			showManualModal: {
				get () {
					return this.$store.getters.showManualModal
				},
				set () {
					this.$store.commit('toggleManualModal')
				}
			}
		},


		methods: {
			changeManualModalState () {
                this.$store.commit('toggleManualModal')
            }
		}
	}
</script>

<style>
	ol {
		list-style-position: inside;
	}
</style>